import React from "react";
import { Box, Button } from "@mui/material";
import { CommonLandingPageSteps } from "../../AddEditLandingPage.types";
import StepContainer from "../../components/StepContainer";
import { ClipLoader } from "react-spinners";

export default function PreviewAndLaunchStep({
    onSave,
    form,
    pageURL,
    lastAddedDraftLandingPage,
    isLandingPageFormLoading,
}) {
    const previewUrl = `${pageURL}?test=preview`; // fallback for testing
    return (
        <StepContainer
            onSubmit={() => {}}
            handleSubmit={() => {}}
            isDirty={true}
            renderButtons={() => (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "16px",
                        height: "fit-content",
                    }}
                >
                    <Box className="position-relative overflow-hidden z-1">
                        {isLandingPageFormLoading && (
                            <div className="circle-loader">
                                <ClipLoader color={"#000"} size={17} />
                            </div>
                        )}
                        <Button
                            variant="contained"
                            color="primary"
                            style={{
                                height: "100%",
                            }}
                            onClick={() =>
                                onSave({
                                    stepName:
                                        CommonLandingPageSteps.PREVIEW_AND_LAUNCH,
                                })
                            }
                        >
                            Publish
                        </Button>
                    </Box>
                </Box>
            )}
        >
            {/* Preview Area */}
            <Box
                sx={{
                    height: "80vh",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    overflow: "hidden",
                    mb: 4,
                }}
            >
                <iframe
                    src={previewUrl}
                    style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                    }}
                    title="Landing Page Preview"
                />
            </Box>
        </StepContainer>
    );
}
